import type { RouteRecordRaw } from 'vue-router'

import { PageEnum } from '@/enums/pageEnum'
import { PAGE_NOT_FOUND_ROUTE } from './basic'
import authorization from './modules/authorization'
import receivedMessage from './modules/received-message'
import product from './modules/product'
import sendCart from './modules/sendCart'
import sendMail from './modules/sendMail'
import folderInfo from './modules/folderInfo'
import recipientMaster from './modules/recipientMaster'
import transactionHistory from './modules/transactionHistory'
import userInfo from './modules/userInfo'
import corporateInfo from './modules/corporateInfo'
import help from './modules/help'
import tradeInfoSuccession from './modules/trade-info-succession'
import bulkUploadFiles from './modules/bulk-upload-files'

const routeModuleList: RouteRecordRaw[] = [
  authorization,
  receivedMessage,
  product,
  sendCart,
  sendMail,
  folderInfo,
  recipientMaster,
  transactionHistory,
  userInfo,
  corporateInfo,
  help,
  tradeInfoSuccession,
  bulkUploadFiles,
  { path: '/top', redirect: '/authorization' },
  { path: '/password-reset', redirect: '/authorization/password-reset-complete' },

  // NOTE: Task 2046, demo. 実装する際は削除。
  {
    path: '/upload-demo',
    component: () => import('@/views/UploadDemo.vue'),
    beforeEnter(to, from, next) {
      process.env.NODE_ENV === 'staging' || process.env.NODE_ENV === 'production'
        ? next('*')
        : next()
    },
  },
]

export const RootRoute: RouteRecordRaw = {
  path: '/',
  name: 'Root',
  redirect: sessionStorage.getItem('id_token') ? PageEnum.BASE_HOME : PageEnum.TOP,
}

export const HomeRoute: RouteRecordRaw = {
  path: '/home',
  name: 'Home',
  redirect: PageEnum.BASE_HOME,
}

export const UIConfirmRoute: RouteRecordRaw = {
  path: '/ui',
  name: 'UIConfirm',
  component: () => import(/** webpackChunkName "ui-confirm" */ '@/views/UIPage.vue'),
}

export const routes = [
  RootRoute,
  HomeRoute,
  ...routeModuleList,
  PAGE_NOT_FOUND_ROUTE,
  UIConfirmRoute,
]
